import { useState } from 'react';
import { useUserContext } from '@nexus/fff-utilities';
import { simpleFetchWithHttp } from './customFetch';

export const updateSubscription = (plan, currentPlan) => simpleFetchWithHttp(
  '/api/1/upgrade',
  {
    method: 'POST',
    body: JSON.stringify({ target_plan_code: plan, current_plan_code: currentPlan }),
  },
  process.env.REACT_APP_REGISTRATION_API,
);

export const ShowErrorOrRedirectThankYouPage = (history, thankYouPagePath, currentPlan) => {
  const { invalidateUserCache } = useUserContext();

  const [status, setStatus] = useState({
    showUpdatePayment: false,
    errorPaymentMessage: '',
    showRetry: false,
    isLoading: false,
  });

  const retry = (error, response) => {
    // eslint-disable-next-line no-console
    console.error(error, response);
    setStatus({
      showUpdatePayment: false,
      errorPaymentMessage: '',
      showRetry: true,
      isLoading: false,
    });
  };
  const onClose = () => {
    setStatus({
      showUpdatePayment: false,
      errorPaymentMessage: '',
      showRetry: false,
      isLoading: false,
    });
  };
  const changeSubscription = (plan) => {
    setStatus({ ...status, isLoading: true });
    updateSubscription(plan, currentPlan).then(
      (response) => {
        if (response.ok) {
          setTimeout(() => {
            invalidateUserCache();
            window.dispatchEvent(new Event('re-render GlobalNav'));
          }, 200);
          history.push(thankYouPagePath);
        } else if (response.status === 422) {
          response.json().then((body) => {
            if (body.is_transaction_error) {
              setStatus({
                showUpdatePayment: true,
                errorPaymentMessage: body.customer_message,
                showRetry: false,
                isLoading: false,
              });
            } else {
              retry('It is not a transaction_error', response);
            }
          }).catch((error) => {
            retry(error, response);
          });
        } else {
          retry('It is a 422', response);
        }
      },
    ).catch((error) => {
      retry(error);
    });
  };

  return { ...status, changeSubscription, onClose };
};
